import React from "react";
import UnifiedFormComponent from "./components/UnifiedFormComponent";

const LaporanHarddisk = () => {
  const handleSuccess = (result) => {
    console.log('Harddisk data saved successfully:', result);
  };

  const handleError = (error) => {
    console.error('Error saving Harddisk data:', error);
  };

  return (
    <UnifiedFormComponent 
      formType="harddisk"
      onSuccess={handleSuccess}
      onError={handleError}
    />
  );
};

export default LaporanHarddisk;
